module.exports = __webpack_public_path__ + "img/banner-princiapal.b4395dff.png";